export function buildTopologyWarningsList(
  warnings?: TopologyWarning[],
): string | undefined {
  if (!warnings?.length) return undefined;
  if (warnings.length === 1) return warnings[0].message;

  return warnings.map((warning) => warning.message).join(' :: ');
}
